import Vue from 'vue'



Vue.directive('tapmode', function(el, binding) {
    var classname = el.className;
    el.ontouchstart = function() {
        el.className = classname + ' ' + binding.value
    };
    el.ontouchend = function() {
        el.className = classname;
    };
})


// WEBPACK FOOTER //
// ./src/directives/index.js